module.exports = __webpack_public_path__ + "img/Lego_Kids_cs.6a8434a5.png";